module.exports = __webpack_public_path__ + "assets/img/title-banner.0abda237.png";